module.exports = __webpack_public_path__ + "img/exclamation_mark_grey.4eb994f7.svg";